/* eslint-disable no-nested-ternary */
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import {
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { formatNumberUsingRegex } from '../../../../pricing-simulator';
import {
  Header,
  InputType,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import DisplayCell from '../../../../pricing-simulator/components/table-columns/display-cell';
import React, { useState } from 'react';
import { useAppSelector } from 'src/hooks';
import DtPBIChart from './dt-pbi-chart-component';

interface DTCellProps {
 info: any;
 moduleId: number;
 sourceId: number;
 scenarioId: number;
}
const DTCell: React.FC<DTCellProps> = ({ info, moduleId, sourceId, scenarioId }) => {
 /** local state for dialog open/close */
 const [isDTDialogOpen, setDTDialogOpen] = useState(false);
 // const { globalFilterValue } = useAppSelector((state) => state.filters);
 /** handler for onclick of dt chart icon */
 const handleOnClick = () => {
   setDTDialogOpen(true);
 };
 /** handler for closing dt modal */
 const handleClose = () => {
   setDTDialogOpen(false);
 };
 const dtColumnStyle = {
   width: '100%',
   display: 'flex',
   justifyContent: 'center',
 };
 return (
<div style={dtColumnStyle}>
<IconButton aria-label="close" onClick={handleOnClick}>
<img
         src="/static/images/dt-image.svg"
         alt="pbi-icon"
         role="pbi-role"
       />
</IconButton>
<Dialog
       fullWidth
       open={isDTDialogOpen}
       disableEscapeKeyDown
>
<DialogTitle id="alert-dialog-title" px={2}>
         DT Output
<IconButton
           aria-label="close"
           onClick={handleClose}
           sx={{
             position: 'absolute',
             right: 8,
             top: 8,
             color: (theme) => theme.palette.grey[500],
           }}
>
<CloseIcon />
</IconButton>
</DialogTitle>
<DialogContent>
<DtPBIChart
           info={info}
           moduleId={moduleId}
           sourceId={sourceId}
           scenarioId={scenarioId}
         />
</DialogContent>
</Dialog>
</div>
 );
};
export default function getColumnForDTType(
  columnData: Header,
  moduleId: number,
  sourceId: number,
  scenarioId: number,
  isDisplayHeader?: boolean,
  maxVal?: number,
  componentType?: any
  // footerRows?: any[] = []
) {
  // style for DT column
  const dtColumnStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  };
  return {
    accessorKey: columnData.parent.parent_field,
    id:
      columnData.parent.parent_field !== ''
        ? columnData.parent.parent_field
        : columnData.parent.order,

    cell: (info: any) => (
<DTCell
       info={info}
       moduleId={moduleId}
       sourceId={sourceId}
       scenarioId={scenarioId}
     />
   ),
   meta: {
     className: '',
   },
    header: () => (
      <Grid container alignItems='center' flexDirection='column'>
        <Grid
          item
          xs='auto'
          container
          alignItems='center'
          className='change-text'
        >
          {isDisplayHeader ? (
            <Grid item sx={{ cursor: 'pointer' }}>
              <span id='dt-header'>{columnData.parent.alias}</span>
              {getHeaderName(columnData)}
            </Grid>
          ) : null}
        </Grid>
      </Grid>
    )
  };
}
